import React, { useState, useEffect } from "react";
import { sbFetch } from "../utils/supabaseClient";
import "../styles/ListTab.css";

const NewsListTab = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNews();
  }, []);

  const loadNews = async () => {
    try {
      setLoading(true);
      const data = await sbFetch("GET", "news?order=published_at.desc");
      setNews(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error loading news:", err);
      alert("Failed to load news");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this news item?")) return;

    try {
      await sbFetch("DELETE", `news?id=eq.${id}`);
      setNews(news.filter((n) => n.id !== id));
      alert("News item deleted successfully!");
    } catch (err) {
      console.error("Error deleting news:", err);
      alert("Failed to delete news item");
    }
  };

  if (loading) return <div className="loading">Loading news...</div>;

  if (news.length === 0)
    return <div className="empty-state">No news items found. Create one first!</div>;

  return (
    <div className="list-container">
      <h2>All News Items ({news.length})</h2>

      <div className="items-grid">
        {news.map((item) => (
          <div key={item.id} className="item-card">
            {item.image_url && (
              <img src={item.image_url} alt={item.title} style={{ width: "100%", height: "150px", objectFit: "cover", borderRadius: "8px", marginBottom: "12px" }} />
            )}
            <div className="item-content">
              <h4>{item.title}</h4>
              <p className="item-meta">
                📅 {item.published_at ? new Date(item.published_at).toLocaleDateString() : "No date"}
              </p>
              <p className="item-subtitle" style={{ fontSize: "12px", color: "#9DB4D4" }}>
                {item.url}
              </p>
            </div>
            <div className="item-actions">
              <a href={item.url} target="_blank" rel="noopener noreferrer" style={{ padding: "6px 12px", background: "#0066B2", color: "white", borderRadius: "6px", textDecoration: "none", fontSize: "12px" }}>
                Open
              </a>
              <button
                className="btn-delete"
                onClick={() => handleDelete(item.id)}
                style={{ padding: "6px 12px", background: "#DC2626", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", fontSize: "12px" }}
              >
                🗑️
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsListTab;
